import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "senders-view" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "delete-confirmation" }
const _hoisted_4 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_Download = _resolveComponent("Download")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_sender_information = _resolveComponent("sender-information")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Warning = _resolveComponent("Warning")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Управление договорами с МНОС", -1)),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreateDialog = true))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Plus)
            ]),
            _: 1
          }),
          _cache[5] || (_cache[5] = _createTextVNode(" Добавить отправителя "))
        ]),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.senders,
      style: {"width":"100%"},
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "Наименование",
          "min-width": "200"
        }),
        _createVNode(_component_el_table_column, {
          prop: "type",
          label: "Тип",
          width: "180"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.senderTypeLabels[row.type as SenderTypeEnum]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "inn",
          label: "ИНН",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "bank_name",
          label: "Банк",
          "min-width": "200"
        }),
        _createVNode(_component_el_table_column, {
          prop: "bank_bik",
          label: "БИК",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "Действия",
          width: "150",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  circle: "",
                  size: "large",
                  onClick: ($event: any) => (_ctx.handleEdit(row))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Edit)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  circle: "",
                  size: "large",
                  onClick: ($event: any) => (_ctx.handleDownload(row))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Download)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "danger",
                  circle: "",
                  size: "large",
                  onClick: ($event: any) => (_ctx.handleDelete(row))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Delete)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showCreateDialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showCreateDialog) = $event)),
      title: _ctx.editingSender ? 'Редактировать отправителя' : 'Новый отправитель',
      width: "80%",
      top: "4vh",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        (_ctx.showCreateDialog)
          ? (_openBlock(), _createBlock(_component_sender_information, {
              key: 0,
              "is-standalone": true,
              "initial-sender": _ctx.editingSender,
              onSave: _ctx.handleSave,
              onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCreateDialog = false))
            }, null, 8, ["initial-sender", "onSave"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showDeleteDialog,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showDeleteDialog) = $event)),
      title: "Подтверждение удаления",
      width: "30%",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDeleteDialog = false))
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("Отмена")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _ctx.confirmDelete,
            loading: _ctx.loading
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode(" Удалить ")
            ])),
            _: 1
          }, 8, ["onClick", "loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_icon, {
            class: "warning-icon",
            color: "#F56C6C"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Warning)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, "Вы уверены, что хотите удалить отправителя \"" + _toDisplayString(_ctx.senderToDelete?.name) + "\"?", 1),
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "warning-text" }, "Это действие нельзя будет отменить.", -1))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}